/*
 * First query for my profile valid Tickets/Vouchers data
 */
export default {
    showValid: true,
    page: 1,
}